import React, { useState, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { MdPerson, MdWarning, MdInfoOutline } from 'react-icons/md';

import {
  verifyValidationRequest,
  closeValidationModal,
  resetValidation,
} from '~/store/modules/pickupValidation/actions';
import {
  CourierCard,
  CourierPhoto,
  CourierInfo,
  Field,
  Button,
  ModalFooter,
  AttemptsBadge,
  StatusMessage,
} from '../styles';

export default function StepVerifyCourier({ cartId }) {
  const dispatch = useDispatch();
  const { validation, loadingVerify } = useSelector(
    state => state.pickupValidation
  );

  const [name, setName] = useState('');
  const [plate, setPlate] = useState('');

  const { courier } = validation;
  const hasPhoto = courier && courier.photo_url;
  const plateAvailable = Boolean(courier && courier.plate_available);

  const handleNameChange = useCallback(e => {
    setName(e.target.value);
  }, []);

  const handlePlateChange = useCallback(e => {
    setPlate(e.target.value.toUpperCase());
  }, []);

  const handleSubmit = useCallback(() => {
    if (!name.trim() || !plate.trim()) return;

    dispatch(
      verifyValidationRequest(cartId, {
        name: name.trim(),
        plate: plate.trim(),
      })
    );
  }, [dispatch, cartId, name, plate]);

  const handleAbort = useCallback(() => {
    dispatch(closeValidationModal());
    dispatch(resetValidation());
  }, [dispatch]);

  // Item 3: Sem placa do parceiro = não há como validar com segurança.
  if (!plateAvailable) {
    return (
      <>
        <StatusMessage variant="warning">
          <MdWarning size={48} />
          <div className="title">Placa não fornecida pelo parceiro</div>
          <div className="subtitle">
            O parceiro de entregas não retornou a placa do veículo deste
            entregador. A validação de segurança não pode prosseguir sem essa
            informação.
            <br />
            <br />
            <strong>
              Cancele esta entrega e solicite uma nova pelo fluxo normal da
              venda para garantir o seguro do pedido.
            </strong>
          </div>
        </StatusMessage>

        <ModalFooter style={{ padding: '16px 0 0', border: 0 }}>
          <Button type="button" onClick={handleAbort}>
            Fechar
          </Button>
        </ModalFooter>
      </>
    );
  }

  return (
    <>
      <CourierCard>
        <CourierPhoto src={hasPhoto ? courier.photo_url : undefined}>
          {!hasPhoto && <MdPerson size={32} />}
        </CourierPhoto>
        <CourierInfo>
          <div
            className="detail"
            style={{
              fontSize: 12,
              color: '#888',
              display: 'flex',
              alignItems: 'flex-start',
              gap: 6,
              marginTop: 4,
              lineHeight: 1.35,
            }}
          >
            <MdInfoOutline size={14} style={{ flexShrink: 0, marginTop: 2 }} />
            <span>
              Solicite ao entregador o nome e placa do veículo conforme é
              exibido no app de entregas dele.
            </span>
          </div>
        </CourierInfo>
      </CourierCard>

      <Field>
        <label>Nome informado pelo entregador</label>
        <input
          type="text"
          value={name}
          onChange={handleNameChange}
          placeholder="Nome completo"
        />
      </Field>

      <Field>
        <label>Placa do veículo</label>
        <input
          type="text"
          value={plate}
          onChange={handlePlateChange}
          placeholder="ABC1D23"
          maxLength={15}
        />
      </Field>

      <ModalFooter style={{ padding: '16px 0 0', border: 0 }}>
        <Button
          type="button"
          onClick={handleSubmit}
          disabled={loadingVerify || !name.trim() || !plate.trim()}
        >
          {loadingVerify ? 'Validando...' : 'Validar dados'}
        </Button>
      </ModalFooter>

      <AttemptsBadge danger={validation.attempts_remaining === 1}>
        {validation.attempts_remaining} tentativa(s) restante(s)
      </AttemptsBadge>
    </>
  );
}
